
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embeddable/fmdq",
      function () {
        return require("private-next-pages/embeddable/fmdq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embeddable/fmdq"])
      });
    }
  